import { render } from "./LaRevuePage.vue?vue&type=template&id=6c3b01aa"
import script from "./LaRevuePage.vue?vue&type=script&lang=js"
export * from "./LaRevuePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__